module.exports = __webpack_public_path__ + "img/03.1997ac41.png";